import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFarmLandUseChanges, setFarmLandUseChangesAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN } from "consts";

import { LandUseChangeRequestPayload } from "models";

export const useMutateFarmLandUseChanges = (farmId: string, year: number, range: number, payload: LandUseChangeRequestPayload, primaryDataId?: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFarmLandUseChangesAdmin : setFarmLandUseChanges;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, farmId, year, range],
      mutationFn: () => queryFn(farmId, payload, year, range),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_LAND_USE_CHANGE_USAGE, farmId, year],
          [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId],
          [FOOTPRINTING_FARM, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
